import React, { useState, useEffect } from 'react';

import { useRouter } from 'next/router';

import { useForm } from 'react-hook-form';
// Request Dependency
import { useMutation } from 'react-query';
import { registerService } from 'services/auth';
import { setAuthorization } from 'utils/authentication';

import useDeviceIdentify from 'hooks/use-deviceidentify';
// Toasting error Response
import UseToast from 'hooks/use-toast';
// Custom Components
import TextInput from '@core/components/textinput/TextInput';
import PasswordInput from '@core/components/passwordinput/PasswordInput';
import ActionButton from '@core/components/actionbutton/ActionButton';
import BackButton from '@core/components/backbutton/BackButton';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import classes from './Register.module.scss';
import Link from 'next/link';

const CompanyRegister = () => {
	const { handleDeviceIdentification } = useDeviceIdentify();
	const [originUrl, setOriginUrl] = useState('');
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();
	const { mutate: callRegisterApi, isLoading } = useMutation(registerService, {
		onSuccess: (data, variables) => {
			setAuthorization(data.data);
			handleDeviceIdentification();
			router.replace('/company/register-verify', {
				query: { userEmail: variables.email },
				pathname: '/company/register-verify'
			});
		},
		onError: (error) => {
			toast(error?.response?.data?.data || 'Something went wrong! please try again', 'Alert');
		}
	});

	const seoProps = generateSeoProps({
		title: 'Pharmuni | Company Register',
		canonical: 'register'
	});

	// setup UseForm
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({ mode: 'onChange', delayError: 1000 });

	const onSubmit = (value) => {
		// registerService();
		callRegisterApi(value);
	};
	useEffect(() => {
		if (typeof window !== 'undefined') {
			setOriginUrl(window.location.origin);
		}
	}, []);

	return (
		<>
			<NextSeo {...seoProps} />
			<ToastContainer />
			<div className={`${classes['register-wrapper']} d-flex flex-column align-items-center `}>
				<div className={`${classes['register']}  d-flex flex-column align-items-stretch`}>
					<BackButton type="text" className="d-none d-md-flex my-4" />
					<h1>Company Registration</h1>
					<form onSubmit={handleSubmit(onSubmit)}>
						<TextInput
							validation={{
								required: true,
								pattern: {
									value:
										/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
									message: 'Please enter a correct email address'
								}
							}}
							input={{
								type: 'email',
								label: 'Email Address',
								name: 'email',
								placeholder: 'Email',
								id: 'email',
								autoComplete: 'off'
							}}
							errors={errors}
							register={register}
						/>
						<PasswordInput errors={errors} register={register} />
						<p>
							By creating an account, you agree to our{' '}
							<a href={`${originUrl}/terms-and-conditions/`} rel="noreferrer">
								terms and conditions
							</a>{' '}
							and{' '}
							<a href={`${originUrl}/privacy-policy/`} rel="noreferrer">
								privacy policy
							</a>
							.
						</p>
						<ActionButton
							type="submit"
							disabled={isLoading}
							loading={isLoading}
							kind="secondary_main">
							Create account{' '}
						</ActionButton>
					</form>
					<p
						className={`${classes['register-login']} w-100 align-items-center justify-content-center py-4`}>
						Already registered? <Link href={`/login?next=/company`}>Login</Link>
					</p>
				</div>
			</div>
		</>
	);
};

export default CompanyRegister;
